import React from 'react';
import styled from '@emotion/styled';

import Stacheldraht from '../Stacheldraht';
import ExternalLinksCollection, { ExternalLinksShape } from '../ExternalLinksCollection';

import { showOnlyOnDesktop } from '../styles/breakpoints';

const Container = styled.section`
  margin-bottom: 60px;
  padding-top: 10px;
`;

const StacheldrahtStyled = styled(Stacheldraht)`
  ${showOnlyOnDesktop};
  position: relative;
  top: 0;
  left: 38%;
`;

const ProofOfSources = ({ sources }) => (
  <Container>
    <ExternalLinksCollection headline="Quellen und weitere Informationen" sources={sources} showIds />
    <StacheldrahtStyled small />
  </Container>
);

ProofOfSources.propTypes = {
  sources: ExternalLinksShape.isRequired,
};

export default ProofOfSources;



// WEBPACK FOOTER //
// ./src/components/ProofOfSources/ProofOfSources.js